export var AccountProvider;
(function(AccountProvider) {
    AccountProvider["PP"] = "PRIORITY_PASS";
    AccountProvider["LK"] = "LOUNGE_KEY";
    AccountProvider["PP_PREFERRED"] = "PP_PREFERRED";
})(AccountProvider || (AccountProvider = {}));
export function getAccountProviders() {
    return [
        "PRIORITY_PASS",
        "LOUNGE_KEY",
        "PP_PREFERRED"
    ];
}
export default AccountProvider;
